import {
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  Switch,
  Button,
  message,
} from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { getUserDetail, updateUser } from "../api/user";

export default function UserDetail() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      const res = await getUserDetail(id);
      const data = res.data;

      form.setFieldsValue({
        ...data,
        birthday: data.birthday ? dayjs(data.birthday) : null,
      });
    };
    fetchUser();
  }, [id, form]);

  const onSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      await updateUser(id, {
        ...values,
        birthday: values.birthday?.toISOString(),
      });

      message.success("保存成功");
      setEditable(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title="用户详细信息"
      extra={
        editable ? (
          <Button type="primary" loading={loading} onClick={onSave}>
            保存
          </Button>
        ) : (
          <Button onClick={() => setEditable(true)}>编辑</Button>
        )
      }
    >
      <Form form={form} layout="vertical" disabled={!editable}>
        {/* 账号信息 */}
        <Card type="inner" title="账号信息">
          <Form.Item label="用户名" name="username">
            <Input disabled />
          </Form.Item>

          <Form.Item label="邮箱" name="email">
            <Input />
          </Form.Item>

          <Form.Item label="电话" name="phone">
            <Input />
          </Form.Item>
        </Card>

        {/* 基本信息 */}
        <Card type="inner" title="基本信息" style={{ marginTop: 16 }}>
          <Form.Item label="姓名" name="name">
            <Input />
          </Form.Item>

          <Form.Item label="性别" name="gender">
            <Select
              options={[
                { value: "male", label: "男" },
                { value: "female", label: "女" },
              ]}
            />
          </Form.Item>

          <Form.Item label="生日" name="birthday">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Card>

        {/* 身份信息 */}
        <Card type="inner" title="身份信息" style={{ marginTop: 16 }}>
          <Form.Item label="身份证号" name="idCard">
            <Input />
          </Form.Item>

          <Form.Item label="护照号" name="passport">
            <Input />
          </Form.Item>
        </Card>

        {/* 权限与状态 */}
        <Card type="inner" title="权限与状态" style={{ marginTop: 16 }}>
          <Form.Item label="是否激活" name="active" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item label="角色" name="role">
            <Select
              options={[
                { value: "user", label: "普通用户" },
                { value: "admin", label: "管理员" },
              ]}
            />
          </Form.Item>
        </Card>

        {/* 备注 */}
        <Card type="inner" title="备注" style={{ marginTop: 16 }}>
          <Form.Item name="notes">
            <Input.TextArea rows={4} />
          </Form.Item>
        </Card>
      </Form>
    </Card>
  );
}
